export function toCamelCase(input) {
    return input.split(/[^a-zA-Z\d]+/)
        .map((word, index) => index === 0 ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join('');
}

export function filterContent(content) {
    const { id, type, ...newContent } = content;

    return newContent;
}
